import './index.css'
import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Chip from "@mui/material/Chip";
import TuneIcon from "@mui/icons-material/Tune";
import BadgeIndicator from "../common/BadgeIndicator";
import InputSearch from "../common/InputSearch";
import AddChip from "../common/ActionChip/AddChip";
import { useNavigate } from "react-router-dom";


export default function SitesListingActions({ selectedProject }: any) {
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="sites-listing-actions-toolbar-box" >
        <span className="sites-listing-actions-toolbar__item-left">
          <InputSearch
            name='name'
            value={''}
            placeholder="Nombre"
            onChange={() => { }}
            onSubmitSearch={() => { }}
            onResetSearch={() => { }}
          />
        </span>

        {(selectedProject) && (

          <div className="sites-listing-actions-toolbar__item-right">
            <BadgeIndicator
              element={(<Chip
                icon={<TuneIcon color="success" />}
                label="Filtros"
                clickable
                onClick={() => { }} />)
              }
              indicator={null}
            />

            <AddChip
              onClick={() => navigate('/site/create')}
              label='Nuevo Sitio'
            />

          </div>
        )}

      </div>
    </React.Fragment>
  );
}
